module.exports = __webpack_public_path__ + "img/middlecontrol.b50c21e1.svg";